export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_40-6d79f6cb7142ffcd6e7cc3b7feaaeedf.jpg";